import React from "react";
import { ModalType, useModal } from "../../../../Context/ModalContext";


function TextSizeSelector(  ) {
  const { toggleShow } = useModal();
  return (
    <div className="toolbar-button"
         onClick={ () => {toggleShow( true, null, ModalType.textSize );} }
         data-test={"text-size"}>
      <i className="far fa-text-size"></i>
    </div>
  );
}

export default TextSizeSelector;